import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Albaran/eliminarAlbaranSeleccion`, method: 'POST', body: {list}, token: token})
}